import React, { useContext, useState, useEffect } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Form, Dropdown, Label } from 'semantic-ui-react';
import Utility from './../../../Utility';

/**
 * Component InputSelect
 * Retourne le jsx d'un select
 * @param {bool} string.value
 * @param {bool} props.required
 * @param {bool} props.error
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.labelError
 * @param {string} props.typePattern
 * @param {object} props.style
 * @param {array} props.data
 * @param {bool} props.search
 * @param {bool} props.compact
 * @param {func} props.handleReload
 * @param {func} props.handleChange
 * @param {bool} props.disabled
 */
const InputSelect = (props) => {
  let { required, name, label, labelError, data, search, compact, style, disabled } = props;
  const [globalContext] = useContext(GlobalContext);
  const [valueState, setValueState] = useState(props.value);
  const [errorState, setErrorState] = useState(false);

  if(data === undefined) {
    data = [{ key:'', text: '', value: ''}];
  }
  
  useEffect(() => {
    if (props.value !== undefined) {
      setValueState(props.value);
    }
    if (props.error !== undefined) {
      setErrorState(props.error);
    }
  }, [globalContext.translations, props])

  /**
   * Event lorsque la valeur de l'input change
   */
  const handleChange = (event, { value }) => {
    let test = Utility.checkValue(name, value, props.typePattern);
    if (props.handleReload) {
      props.handleReload(test);
    }
    if (props.handleChange) {
      props.handleChange(name, value);
    }
    setErrorState(test.error);
    setValueState(value);
  }

  /**
   * Rendu du label en cas d'erreur
   * @returns Object jsx
   */
  const getLabelError = () => {
    if (errorState && labelError) {
      return (
        <Label basic color="red" pointing>
          {(labelError === true) ? globalContext.translations.enterValue : labelError}
        </Label>
      );
    } else {
      return null
    }
  }

  /**
   * Rendu du component
   * @returns Object jsx
   */
    return (
      <Form.Field required={required} error={errorState}>
        <label>{label}</label>
        <Dropdown
          selection
          placeholder={label}
          options={data}
          value={valueState}
          search={search}
          onChange={handleChange}
          compact={compact}
          style={style}
          disabled={disabled}
        >
        </Dropdown>
        <input type="hidden" name={'input_' + name} value={valueState} />
        {getLabelError()}
      </Form.Field>
    )
}

export default InputSelect;
